export default ({ request }) => ({
  SYS_USER_LOGIN(data = {}) {
    return request({
      baseURL: '/api',
      url: '/auth/login',
      method: 'post',
      data
    })
  },
  SYS_USER_LOGOUT() {
    return request({
      baseURL: '/api',
      url: '/auth/logout',
      method: 'post'
    })
  },
  SYS_USER_INFO(data = {}) {
    return request({
      url: '/digitalCenter/baseUser/getUserInfo',
      method: 'post',
      data
    })
  },
  SYS_USER_CHANGE_AVATAR(data = {}) {
    return request({
      url: '/digitalCenter/baseUser/changeAvatar',
      method: 'post',
      data
    })
  },
  SYS_USER_UPD_PWD(data = {}) {
    return request({
      url: '/sys/user/modifyPassword',
      method: 'post',
      data
    })
  },
  SYS_USER_DETAIL(data = {}) {
    return request({
      url: '/sys/user/detail',
      method: 'post',
      data
    })
  }
})
